import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';

export const benchesProductListConfig: ProductListConfig = {
  cluster: [],
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  productFilters: [],
  sortOrder: [{ path: 'name' }, { path: 'designText' }, { path: 'communicatedSizeText' }],

  categories: [
    {
      id: 'benches',
      products: [
        { path: 'type', value: ProductType.BROR_WORK_BENCH },
        { path: 'type', value: ProductType.BROR_TROLLEY }
      ]
    }
  ]
};
